import React from 'react'

const Info = function info (){
    return (
        <main>
            <div class="row contentImg">
                <div class="col s12">
                    <img src={https+'img/payu.png'} alt=""/>
                </div>
            </div>
        </main>
    )
}

export default Info